import React from 'react';
import { MD } from '@zendeskgarden/react-typography';

function ProductsAboutPipeFacts() {
  return (
    <div style={{ maxWidth: '700px', margin: '0 auto' }}>
      <img
        style={{ margin: '0 auto', display: 'block', maxWidth: '200px' }}
        src="/images/PIPEFACTS-HORIZONTAL.png"
        alt="horizontal pipefacts logo"
      />
      <MD grey center paddingTopLg>
        PipeFacts by PipeSearch is a multi-stage process that utilizes
        proprietary software to manage a sequence of QA/QC steps in the
        evaluation of OCTG. It is designed to bring transparency, integrity, and
        consistency to the evaluation of tubulars no matter the location of the
        pipe.
      </MD>
      <MD grey center paddingTopSm>
        PipeFacts goes beyond standard physical inspections of material. It
        evaluates the specification of the original MTRs against API 5CRA or
        5CT, identifies any exceptions, and sets a standard by which MTRs are
        reviewed and by which inspections are performed. Our PipeFacts process
        has been developed to give customers complete confidence in the product
        they are receiving.
      </MD>
    </div>
  );
}

export default ProductsAboutPipeFacts;
